import React from 'react';
import { Box } from '@mui/material';

import PremiumPricingBlock from './PremiumPricingBlock';
import Section from './Section';

export default function PremiumPricingSection({ onGoToPayment = null }) {
  return (
    <Section
      sx={{
        bgcolor: 'transparent',
        color: 'text.primary',
      }}
    >
      <Box sx={{ width: '100%', alignSelf: 'stretch', maxWidth: '100%' }}>
        <PremiumPricingBlock variant="home" onGoToPayment={onGoToPayment} />
      </Box>
      <Box height={24} />
    </Section>
  );
}
